'use strict'

import FilesGroup from '../../components/File/FilesGroup.js'

export default class ReportFilesGroup extends FilesGroup {
  constructor (config) {
    super(config)
    this.remarkIndex = config.remarkIndex || null
    this.required = config.required || false
    this.contentType = null
  }
}
